// Auto-generated! Please DO NOT EDIT!

export type CoreApiResourceName =
  | 'account'
  | 'article'
  | 'auth_external_token'
  | 'auth_request'
  | 'badge'
  | 'ban'
  | 'base_task'
  | 'bound_form'
  | 'calendar_sync_event'
  | 'card'
  | 'category'
  | 'certificate'
  | 'certificate_institution'
  | 'certificate_qualification'
  | 'channel'
  | 'coach_history'
  | 'coach_task'
  | 'complaint'
  | 'conference'
  | 'coupon'
  | 'course'
  | 'diary_entry'
  | 'edition'
  | 'event'
  | 'favorite'
  | 'file'
  | 'follower'
  | 'food'
  | 'food_diary'
  | 'food_share'
  | 'food_tracker'
  | 'form'
  | 'goal'
  | 'invite'
  | 'lead'
  | 'lead_event'
  | 'link'
  | 'material'
  | 'membership'
  | 'message_profile'
  | 'metrics'
  | 'offer'
  | 'payment'
  | 'perk'
  | 'post'
  | 'preloaded_user'
  | 'program'
  | 'questionnaire'
  | 'refund'
  | 'reward'
  | 'reward_profile'
  | 'scheduled_notification'
  | 'session'
  | 'session_note'
  | 'short_link'
  | 'subgoal'
  | 'subtenant'
  | 'task'
  | 'tenant'
  | 'tier'
  | 'used_coupon'
  | 'user'
  | 'user_contact'
  | 'user_grade'
  | 'user_questionnaire'
  | 'user_reward'
  | 'visit_log'
  | 'waitlist_item';

export const CORE_API_RESOURCE_NAMES: Set<CoreApiResourceName> = new Set([
  'account',
  'article',
  'auth_external_token',
  'auth_request',
  'badge',
  'ban',
  'base_task',
  'bound_form',
  'calendar_sync_event',
  'card',
  'category',
  'certificate',
  'certificate_institution',
  'certificate_qualification',
  'channel',
  'coach_history',
  'coach_task',
  'complaint',
  'conference',
  'coupon',
  'course',
  'diary_entry',
  'edition',
  'event',
  'favorite',
  'file',
  'follower',
  'food',
  'food_diary',
  'food_share',
  'food_tracker',
  'form',
  'goal',
  'invite',
  'lead',
  'lead_event',
  'link',
  'material',
  'membership',
  'message_profile',
  'metrics',
  'offer',
  'payment',
  'perk',
  'post',
  'preloaded_user',
  'program',
  'questionnaire',
  'refund',
  'reward',
  'reward_profile',
  'scheduled_notification',
  'session',
  'session_note',
  'short_link',
  'subgoal',
  'subtenant',
  'task',
  'tenant',
  'tier',
  'used_coupon',
  'user',
  'user_contact',
  'user_grade',
  'user_questionnaire',
  'user_reward',
  'visit_log',
  'waitlist_item',
]);
